import { ConversationStatus } from "@closerplatform/spinner-openapi";
import { Instance, types } from "mobx-state-tree";
import { AgentReferenceType } from "../../../agent";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

/**
 * Conversation status change notification/delimiter
 */
export const StatusChangeChatItem = types.compose(
  "StatusChangeChatItem",
  BaseChatItem,
  types.model({
    type: types.literal(ChatItemType.StatusChange),
    user: types.maybe(AgentReferenceType),
    status: types.enumeration<ConversationStatus>(
      "ConversationStatus",
      Object.values(ConversationStatus)
    )
  })
);

export interface IStatusChangeChatItem extends Instance<typeof StatusChangeChatItem> {}
